import mutations from './bnoArchive.mutations'
import actions from './bnoArchive.actions'
import getters from './bnoArchive.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
